(function () {
  var config = window.DairyAssureMetaPixel || {};
  var cartState = config.cart || null;
  var checkoutTracked = false;

  function canTrack() {
    return typeof window.fbq === 'function';
  }

  /*
    Every browser event needs its own event_id. Meta's Conversions API mirrors these
    browser events server-side, and deduplication requires matching event_name AND
    event_id. Without an event_id the server copy cannot be collapsed against the
    browser copy, which is what produced the duplicate-event investigation on
    2026-07-27. See docs/meta-duplicate-events-diagnosis.md.
  */
  function newEventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        var hex = '';
        for (var i = 0; i < bytes.length; i++) {
          hex += ('0' + bytes[i].toString(16)).slice(-2);
        }
        return hex;
      }
    } catch (error) {
      /* fall through to the non-crypto path below */
    }

    return 'da-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function track(eventName, payload) {
    if (!canTrack()) return;
    window.fbq('track', eventName, payload || {}, { eventID: newEventId() });
  }

  function centsToAmount(value) {
    var amount = Number(value || 0);
    return Number.isFinite(amount) ? amount / 100 : 0;
  }

  function cartItemPayload(item) {
    if (!item) return {};

    var quantity = Number(item.quantity || 1);
    var price = centsToAmount(item.final_price || item.price || item.presentment_price);

    return {
      content_ids: [String(item.variant_id || item.id || '')],
      content_name: item.product_title || item.title || 'DairyAssure',
      content_type: 'product',
      contents: [
        {
          id: String(item.variant_id || item.id || ''),
          quantity: quantity,
          item_price: price
        }
      ],
      currency: config.currency || 'USD',
      value: price * quantity
    };
  }

  function cartPayload(cart) {
    if (!cart) {
      return {
        content_type: 'product',
        currency: config.currency || 'USD'
      };
    }

    var items = Array.isArray(cart.items) ? cart.items : [];

    if (items.length > 0) {
      var contents = items.map(function (item) {
        return {
          id: String(item.variant_id || item.id || ''),
          quantity: Number(item.quantity || 1),
          item_price: centsToAmount(item.final_price || item.price || item.presentment_price)
        };
      });

      return {
        content_ids: contents.map(function (item) {
          return item.id;
        }),
        content_type: 'product',
        contents: contents,
        currency: cart.currency || config.currency || 'USD',
        num_items: items.reduce(function (total, item) {
          return total + Number(item.quantity || 0);
        }, 0),
        value: centsToAmount(cart.total_price)
      };
    }

    return {
      content_ids: cart.content_ids || [],
      content_type: 'product',
      contents: cart.contents || [],
      currency: cart.currency || config.currency || 'USD',
      num_items: Number(cart.num_items || 0),
      value: Number(cart.value || 0)
    };
  }

  function refreshCartState() {
    if (typeof window.fetch !== 'function') return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) cartState = cart;
      })
      .catch(function () {});
  }

  function trackProductView() {
    if (!config.product) return;
    track('ViewContent', config.product);
  }

  function trackAddToCart(event) {
    if (!event || event.source !== 'product-form') return;

    var item = event && event.cartData;
    if (item) cartState = cartItemPayload(item);
    track('AddToCart', cartItemPayload(item));
    refreshCartState();
  }

  function trackInitiateCheckout() {
    if (checkoutTracked) return;
    checkoutTracked = true;
    track('InitiateCheckout', cartPayload(cartState));
  }

  function isCheckoutTrigger(element) {
    if (!element || !element.closest) return false;

    return Boolean(
      element.closest('button[name="checkout"], input[name="checkout"], [formaction*="/checkout"], a[href*="/checkout"]')
    );
  }

  function trackSearchSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/search"], form[action*="search"]')) return;

    var field = form.querySelector('input[name="q"], input[type="search"]');
    var query = field ? field.value : '';
    track('Search', { search_string: query || undefined });
  }

  function trackLead(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/contact"], form[action*="contact"]')) return;
    if (!form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) return;

    track('Lead', { content_name: 'Newsletter signup' });
  }

  function bindThemeEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, trackAddToCart);
    }

    document.addEventListener('submit', function (event) {
      trackSearchSubmit(event);
      trackLead(event);

      var submitter = event.submitter;
      if (isCheckoutTrigger(submitter) || event.target.matches('form[action*="/checkout"]')) {
        trackInitiateCheckout();
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (isCheckoutTrigger(event.target)) trackInitiateCheckout();
      },
      true
    );
  }

  refreshCartState();
  trackProductView();
  bindThemeEvents();
})();
